import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const SliderContainer = styled.div`
  width: 420px;
  height: 250px;
  overflow: hidden;
  margin : 10px 0;
  position: relative;

  @media (max-width: 767px) {
    width: calc(100% - 20px);
    height : auto;
  }
`;

const SlidesWrapper = styled.div`
  display: flex;
  transition: transform 0.5s ease-in-out;
  transform: ${({ currentIndex }) => `translateX(-${currentIndex * 100}%)`};
`;

const SlideImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  flex-shrink: 0;
`;

const BulletsContainer = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;

  @media (max-width: 767px) {
    bottom : 10px;
  }
`;

const Bullet = styled.div`
  width: 10px;
  height: 10px;
  margin: 0 5px;
  border-radius: 50%;
  background-color: ${({ isActive }) => (isActive ? '#E75B82' : 'rgba(255, 255, 255, 0.5)')};
  cursor: pointer;
`;

const CustomImageSlider = ({ images, autoPlay, showBullets }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (autoPlay) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 3000); // Change slide every 3 seconds

      return () => clearInterval(interval);
    }
  }, [images.length, autoPlay]);
  
  return (
    <SliderContainer>
      <SlidesWrapper currentIndex={currentIndex}>
      {images.map((image, index) => (
        <SlideImage
          key={index}
          src={image.url}
          alt={`Slide ${index}`}
          isActive={currentIndex === index}
          onClick={() => window.open(image.redirection_link, "_blank")}
        />
      ))}
      </SlidesWrapper>
      {showBullets && (
        <BulletsContainer>
          {images.map((_, index) => (
            <Bullet
              key={index}
              isActive={currentIndex === index}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </BulletsContainer>
      )}
    </SliderContainer>
  );
};

export default CustomImageSlider;
